import { Axios } from '../core/axios';

// ------------------ ACCOUNT ------------------ 
export function verifyToken(token) {
  return Axios.get(`/tokens/${token}/`).then((response) => {
    return response.data;
  });
}

export function getAccountSettings(params, options) {
  return Axios.get('/account/settings/', params, options).then((response) => {
    return response.data;
  });
}

export function updateAccount(uid, params, options) {
  // inform backend to pass along this property to Cognito
  params.fromTrainer = true;
  return Axios
    .patch(`/account/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function signOut(token) {
  return Axios.delete(`/tokens/${token}/`).then((response) => {
    return response.data;
  });
}

// ------------------ TRAINER ------------------ 
export function getTrainer(uid, params, options) {
  return Axios
    .get(`/trainers/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateTrainer(uid, params, options) {
  return Axios
    .patch(`/trainers/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function findUserByEmail(email, params, options) {
  return Axios
    .get(`/account/email/${email}/`, params, options)
    .then(response => {
      return response.data;
    });
}

// ------------------ DASHBOARD ------------------ 
export function getDashboard(params, options) {
  return Axios
    .get(`/dashboard/`, params, options)
    .then(response => {
      return response.data;
    });
}

// ------------------ ACTIVITIES -----------------
export function getActivities(params, options) {
  return Axios
    .get(`/activities/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getActivityByUid(uid, params, options) {
  return Axios
    .get(`/activities/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function createActivity(params, options) {
  return Axios
    .post(`/activities/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateActivity(uid, params, options) {
  return Axios
    .patch(`/activities/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

// ------------------ EXERCISES ------------------ 
export function getExercises(params, options) {
  return Axios
    .get(`/exercises/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getExerciseByUid(uid, params, options) {
  return Axios
    .get(`/exercises/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function createExercise(params, options) {
  return Axios
    .post(`/exercises/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateExercise(uid, params, options) {
  return Axios
    .patch(`/exercises/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getAggregate(params, options) {
  const { endpoint, filter, type } = params;
  const queryString = filter ? `type=${type}&filter=${filter}` : `type=${type}`;
  return Axios
    .get(`/${endpoint}/aggregate/?${queryString}`, params, options )
    .then(response => {
      return response.data;
    });
}

// ------------------ CLASSES ------------------ 
export function getClasses(params, options) {
  return Axios
    .get(`/classes/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getClassByUid(uid, params, options) {
  return Axios
    .get(`/classes/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function createClass(params, options) {
  return Axios
    .post(`/classes/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateClass(uid, params, options) {

  return Axios
    .patch(`/classes/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateClassExerciseVideo(uid, exerciseUid, params, options) {
  return Axios
    .put(`/classexercisevideo/${uid}/${exerciseUid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

// ------------------ PROGRAMS ------------------ 
export function getPrograms(params, options) {
  return Axios
    .get(`/programs/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getProgramByUid(uid, params, options) {
  return Axios
    .get(`/programs/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function createProgram(params, options) {
  return Axios
    .post(`/programs/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateProgram(uid, params, options) {
  return Axios
    .patch(`/programs/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function createProgramSet(id, params) {
  return Axios
    .post(`/programs/${id}/programsets/`, params)
    .then(response => {
      return response.data;
    });
}

export function updateProgramSet(id, programSetID, params) {
  return Axios
    .patch(`/programs/${id}/programsets/${programSetID}/`, params)
    .then(response => {
      return response.data;
    });
}
// -----------=-- DIGITAL COACHING -------------

export function getCompanies(params, options) {
  return Axios
    .get('/companies/', params, options)
    .then(response => {
      return response.data;
    });
}

export function getCompanyUsers(id, params, options) {
  return Axios
    .get(`/companies/${id}/users/`, params, options)
    .then(response => {
      return response.data;
    });
}

export function getCompanyCohorts(id, params, options) {
  return Axios
    .get(`/companies/${id}/cohorts/`, params, options)
    .then(response => {
      return response.data;
    });
}

export function createCompanyCohort(params, options) {
  return Axios
    .post('/cohorts/', params, options)
    .then(response => {
      return response.data;
    });
}

export function updateCompanyCohort(id, params, options) {
  return Axios
    .patch(`/cohorts/${id}/`, params, options)
    .then(response => {
      return response.data;
    });
}

export function getDigitalCoachingTrainers(affiliation, params = {}, options = {}) {
  params.mini = params.mini || false;
  return Axios
    .get(`/affiliated-trainers/${affiliation}/`, { params }, options)
    .then(response => {
      return response.data;
    });
}

export function getWellnessPrograms(params, options) {
  return Axios
    .get('/wellness-programs/', params, options)
    .then(response => {
      return response.data;
    });
}

export function createCohortProgram(params, options) {
  return Axios
    .post('/cohortprograms/', params, options)
    .then(response => {
      return response.data;
    });
}

export function updateCohortProgram(id, params, options) {
  return Axios
    .patch(`/cohortprograms/${id}/`, params, options)
    .then(response => {
      return response.data;
    });
}

export function addMemberToCohort(id, params, options) {
  return Axios
    .post(`/cohorts/${id}/members/`, params, options)
    .then(response => {
      return response.data;
    });
}

export function removeMemberFromCohort(id, memberId, params, options) {
  return Axios
    .delete(`/cohorts/${id}/members/${memberId}/`, params, options)
    .then(response => {
      return response.data;
    });
}

// ------------------ Indivdual Coaching ------------------

export function getMeetTrainerRequestItems(params, options) {
  return Axios
    .get(`/meettrainer/`, params, options)
    .then(response => {
      return response.data;
    });
}
export function updateIndividualCoachForm(uid, params, options) {
  return Axios
    .patch(`/meettrainer/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}
export function getMeetTrainerRequestByUid(uid, params, options) {
  return Axios
    .get(`/meettrainer/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

// ------------------ CHANNEL ------------------

export function getUserChannel(uid, params, options) {
  return Axios
    .get(`/channel/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateChannel(uid, params, options) {
  return Axios
    .patch(`/channel/${uid}/`, params, options )
    .then(response => {
      return response.data;
    });
}

// ------------------ SEARCH ------------------ 

export function query(type, query, params, options) {
  return Axios
    .get(`/${type}/?${query}`, params, options )
    .then(response => {
      return response.data;
    });
}


// ------------------ VIDEO ------------------ 

export function getExerciseVideo(id, params, options) {
  return Axios
    .get(`/exercisevideos/${id}`, params, options )
    .then(response => {
      return response.data;
    });
}

// deprecated
export function uploadExerciseVideo(params, options) {
  return Axios
    .put(`/exercisevideos/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function updateExerciseVideo(id, params, options) {
  return Axios
    .put(`/exercisevideos/${id}/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getOverviewVideos(params, options) {
  return Axios
    .get(`/overviewvideos/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getOverviewVideo(id, params, options) {
  return Axios
    .get(`/overviewvideos/${id}/`, { params }, options)
    .then(response => {
      return response.data;
    });
}

export function updateOverviewVideo(id, params, options) {
  return Axios
    .put(`/overviewvideos/${id}/`, params, options)
    .then(response => {
      return response.data;
    });
}

// deprecated
export function uploadOverviewVideo(params, options) {
  return Axios
    .put(`/overviewvideos/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function addOverviewVideo(params, options) {
  return Axios
    .post('/addoverviewvideos/', params, options)
    .then(response => {
      return response.data;
    });
}

export function addExerciseVideo(params, options) {
  return Axios
    .post('/addexercisevideos/', params, options)
    .then(response => {
      return response.data;
    });
}

export function getStreamingVideoStatus({ overviewVideoIds, exerciseVideoIds }) {
  const overviewParam = overviewVideoIds && overviewVideoIds.length
    ? `overviewvideos=${overviewVideoIds.join(',')}` : '';
  const exerciseParam = exerciseVideoIds && exerciseVideoIds.length
    ? `exercisevideos=${exerciseVideoIds.join(',')}` : '';
  const amp = overviewVideoIds && exerciseVideoIds ? '&' : '';
  return Axios
    .get(`/streamingvideostatus/?${overviewParam}${amp}${exerciseParam}`)
    .then(response => {
      return response.data;
    });
}

// ------------------ AUDIO ------------------
export function addOverviewAudio(params, options) {
  return Axios
    .post('/addoverviewaudios/', params, options)
    .then(response => {
      return response.data;
    });
}

export function getOverviewAudio(id, params, options) {
  return Axios
    .get(`/overviewaudios/${id}/`, params, options)
    .then(response => {
      return response.data;
    });
}

export function updateOverviewAudio(id, params, options) {
  return Axios
    .put(`/overviewaudios/${id}/`, params, options)
    .then(response => {
      return response.data;
    });
}

// ------------------ IMAGE ------------------ 

export function uploadImages(params, options) {
  return Axios
    .put(`/images/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getImages(params, options) {
  return Axios
    .get(`/images/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function addOverviewImage(params, options) {
  return Axios
    .post('/addoverviewimages/', params, options)
    .then(response => {
      return response.data;
    });
}

// ------------------ RESOURCES ------------------ 

export function getCategories(params, options) {
  return Axios
    .get(`/categories/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getEquipment(params, options) {
  return Axios
    .get(`/equipment/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getMuscleGroups(params, options) {
  return Axios
    .get(`/musclegroup/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getIntensityLevel(params, options) {
  return Axios
    .get(`/intensitylevel/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getCities(params, options) {
  return Axios
    .get(`/cities/`, params, options )
    .then(response => {
      return response.data;
    });
}

export function getResources(params, options) {
  return Axios
    .get(`/resources/?for_trainer=True`, params, options )
    .then(response => {
      return response.data;
    });
}

// ------------------ STRIPE ---------------------
export function getStripeTrainerLogin() {
  return Axios
    .get('/stripe/trainer/login/')
    .then(response => {
      return response.data;
    });
}

export function verifyStripeAuthCode(code, state) {
  return Axios
    .post('/stripe/trainer/callback/', {
      code: code,
      state: state
    })
    .then(response => {
      return response.data;
    });
}

// ------------------ STAFF ----------------------
export function submitProfileAndGenerateWorkout(profile, target) {
  let profileData = null;
  return Axios
    .post('/staff/workout-generator/profile/', profile)
    .then(response => {
      profileData = response.data;
      return Axios.post('/staff/workout-generator/', {
        target: target,
        profile: profileData
      });
    })
    .then(response => {
      return {
        profile: profileData,
        workouts: response.data,
      };
    })
}

export function createPaymentIntent(stripeAccount, amount) {
  return Axios
    .post('/staff/payment_intent/', {
      stripe_account: stripeAccount,
      amount: amount
    })
    .then(response => {
      return response.data;
    });
}
  export function getReleaseNotes() {
    return Axios
      .get(`/releasenote/`,)
      .then(response => {
        return response.data;
      });
  }
  export function insertReleaseNotes(params) {
    return Axios
      .post(`/releasenote/`, params)
      .then(response => {
        return response.data;
      }).catch(error => {
        return error.response;
      });
  }
  export function updateReleaseNotes(params) {
    return Axios
      .patch(`/releasenote/`, params)
      .then(response => {
        return response.data;
      });
  }

  export function SendPromoCode(params) {
    return Axios
      .post(`/save/promocode/`, params)
      .then(response => {
        return response.data;
      });
  }

// ------------------ MEDIA ----------------------
export function getPresignedUrl(params) {
  return Axios
    .post('/presignedurl/', params)
    .then(response => {
      return response.data;
    });
}

// ------------------ user progress by chart----------------------
export function findUserChartById(id) {
  return Axios
    .get(`home-feed-trainer-side/?user_id=${id}`)
    .then(response => {
      return response.data;
    });
}
// ------------------ Welcome Video----------------------

export function uploadWelcomeVideo(params, options) {
    return Axios
        .post('/welcome-video/', params, options)
        .then(response => {
            return response.data;
        });
}

/**
 * TODO: to be implemented
 * @returns {Promise<AxiosResponse<any>>}
 */
// export function deleteWelcomeVideo() {
//     return Axios
//         .delete('/welcome-video/')
// }
export function getWelcomeVideo() {
    return Axios
        .get('/welcome-video/')
        .then(response => {
            return response.data;
        });
}